<template>
  <div id="app">
    <Nav></Nav>
    <div class="toptit"></div>
    <div class="block">
      <div>
        <h1>洞悉母婴及年轻群族需求 时刻把握潮流及趋势</h1>
        <h1>
          <p><span>品牌力</span> x 产品力 x 渠道力</p> 多元整合的好伙伴
        </h1>
      </div>
    </div>
    <div class="insight">
      <div class="advantage">
        <h1><span>01</span></h1>
        <h2>卡恩优势</h2>
        <h3>STRENGTHS</h3>
        <div>
          <div class="advantage-left">
            <img src="../assets/kaenyoushi.png"
                 alt="">
          </div>
          <div class="advantage-right">
            <div>
              <div class="Num">
                <p><span>1</span></p>
              </div>
              <div>
                <p class="tit">消费者洞察</p>
                <p>深度洞察消费者需求和发展趋势,为合作伙伴提供定制化、系统化的增长解决方案</p>
              </div>
            </div>
            <div>
              <div class="Num">
                <p><span>2</span></p>
              </div>
              <div>
                <p class="tit">IP价值转化</p>
                <p class="content">为品牌提供IP运用咨询，精准匹配优势资源，量身设计和定制化方案，帮助完成IP价值转化</p>
              </div>
            </div>
            <div>
              <div class="Num">
                <p><span>3</span></p>
              </div>
              <div>
                <p class="tit">产品创意开发</p>
                <p class="content">结合消费者需求和IP特点，设计有趣&实用创意产品，创造新奇体验，提升合作伙伴品牌价值和消费者好感度</p>
              </div>
            </div>
            <div>
              <div class="Num">
                <p><span>4</span></p>
              </div>
              <div>
                <p class="tit">多渠道资源整合</p>
                <p>精准匹配资源，结合各渠道特点和优势，进行资源整合和运用，寻找最优方案，多方价值最大化</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="ability">
      <div class="top">
        <div>
          <span class="num">02</span>
          <span class="power">
            <p style="padding-bottom:15px">卡恩能力</p>
            <p>CAPABILITIES</p>
          </span>
        </div>
      </div>
      <div class="content">
        <div class="content1">
          <img src="../assets/nengli1.png"
               alt="">
          <div class="content-first">
            <div>
              <h1>品牌力</h1>
              <p>全国IP商业化赋能<br />品牌策略应用定制专家</p>
            </div>
          </div>
        </div>
        <div class="content2">
          <div class="content-second">
            <div>
              <h1>营销力</h1>
              <p>深耕母婴行业多年<br />对于消费者洞察分析<br />IP与品牌整合营销专家</p>
            </div>
            <span></span>
          </div>
          <img src="../assets/nengli2.png"
               alt="">
        </div>
        <div class="content3">
          <img src="../assets/nengli3.png"
               alt="">
          <div class="content-third">
            <div>
              <h1>产品力</h1>
              <p>
                设计+开发+供应链管理<br />
                擅长新概念&微创新<br />
                产品开发
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="innovation">
      <h1><span>03</span></h1>
      <h2>卡恩创新</h2>
      <h3>INNOVATION</h3>
      <div class="ThreeContent">
        <div>
          <img src="../assets/chuangxin1.png"
               alt="">
        </div>
        <div class="titAndcontent">
          <div>
            <h1><span>原创产品开发团队</span></h1>
            <h2>热爱并深爱 专业且创意</h2>
            <p>创意不仅仅停留在玩具本身,对于消费场景、Storytelling、IP圈粉都有完整有趣的想法积累众多服务品牌的"定制"研发经验挑战创意设计人员的思维及创新</p>
          </div>
        </div>
      </div>
    </div>
    <BottomNav></BottomNav>
    <div class="dongxi-bg">
      <img src="../assets/dongxi-bg.png" alt="">
    </div>
  </div>
</template>

<script>
import Nav from '../components/Nav'
import BottomNav from '../components/BottomNav'
import Vue from 'vue'
export default {
  name: 'insight',
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
    window.onscroll = function() {
      var scrollTop =
      document.documentElement.scrollTop || document.body.scrollTop;
      var topNav = document.getElementById("topNav");
      if (scrollTop > 0) {
        topNav.style.width = "100%";
        topNav.style.position = "fixed";
        topNav.style.top = "0";
        topNav.style.left = "0";
        topNav.style.paddingLeft = "33.5%";
        // topNav.style.zIndex = 11;

      } else{
        // topNav.style.paddingLeft = "0%";
        // topNav.style.width = "32.42%";
        // topNav.style.left = "33.5%";
        // topNav.style.zIndex = 9;

      }
      // if (scrollTop = 0) {
      //   topNav.style.width = "29.42%";
      // }
    };
  },
  components: { Nav, BottomNav }
}
</script>

<style lang="less" scoped>
#app {
  font-family: "微软雅黑";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  // min-width: 1240px;
  position: relative;
  @media screen and (min-width: 140px) {
    min-width: 1050px;
    margin: 0 auto;
  }
  @media screen and (min-width: 1920px) {
    margin: 0 auto;
    min-width: 1240px;
  }
}
.image {
  width: 100%;
}
.logoImg {
  width: 141px;
  height: 86px;
}
.dongxi-bg{
  position: absolute;
  top: 340px;
  z-index: -10;
  img{
    width: 100%;
  }
}
.tit {
  text-align: left;
  h1 {
    color: #fce04f;
    font-size: 61px;
    font-family: Impact;
    font-weight: 400;
    border-bottom: 4px solid #fce04f;
    width: 67px;
  }
  p {
    font-size: 20px;
  }
}
.block {
  // min-width: 1240px;
  background-color: #333333;
  height: 100px;
  display: flex;
  align-items: center;
  div {
    margin-left: 35%;
    h1 {
      margin: 0;
      color: #ffffff;
      width: fit-content;
      width: -webkit-fit-content;
      width: -moz-fit-content;
      font-weight: bold;
       @media screen and (min-width: 140px) {
        font-size: 24px;
      }
      @media screen and (min-width: 1920px) {
        font-size: 26px;
      }
      p {
        margin: 0;
        display: inline-block;
        color: #fce04f;
        span {
          border-bottom: 4px solid #fce04f;
          padding-bottom: 5px;
        }
      }
    }
  }
}
.toptit {
  width: 100%;
  height: 56px;
}
.insight {
  padding: 0;
  padding-top: 20px;
  // width: 1240px;
  width: 65%;
  margin: 0 auto;
  @media screen and (min-width: 140px) {
        width: 90%;

  }
  @media screen and (min-width: 1320px) {
    width: 65%;
  }
  .advantage {
    padding-bottom: 100px;
    h1 {
      margin: 0;
      color: #fce04f;
      margin-bottom: 10px;
      span {
        border-bottom: 4px solid #fce04f;
        font-size: 60px;
        font-family: Impact;
      }
    }
    h2 {
      margin: 0;
      padding-top: 15px;
      font-weight: bold;
      @media screen and (min-width: 140px) {
        font-size: 18px;
      }
      @media screen and (min-width: 1920px) {
        font-size: 24px;
      }
    }
    h3 {
      margin: 0 0 20px 0;
      font-weight: bold;
      @media screen and (min-width: 140px) {
        font-size: 18px;
      }
      @media screen and (min-width: 1920px) {
        font-size: 24px;
      }

    }
    & > div {
      display: flex;
      justify-content: space-between;
      width: 100%;
      padding-top: 50px;
      & > div {
        width: 50%;
        img {
          width: 100%;
        }
        & > div {
          display: flex;
          justify-content: space-between;
        }
      }
      .advantage-left {
        img {
          width: 100%;
          // height: 435px;
        }
      }
      .advantage-right {
        margin-left: 50px;
        width: 38%;
        padding-right: 120px;
        .Num {
          width: 30px;
          margin-right: 20px;
          margin-top: 6px;
          p {
            position: relative;
            width: 28px;
            height: 19px;
            border: 1px solid #666;
            box-sizing: border-box;
            span {
              position: absolute;
              top: -15px;
              right: 2px;
              font-weight: bold;
              font-weight:400;
              @media screen and (min-width: 140px) {
                font-size: 18px;
              }
              @media screen and (min-width: 1920px) {
                font-size: 23px;
              }
            }
          }
        }
        p {
          margin: 0;
          width: fit-content;
          width: -webkit-fit-content;
          width: -moz-fit-content;
          text-align: left;
          width: 405px;
          color: #666;
          font-weight:400;
          @media screen and (min-width: 140px) {
            font-size: 14px;
          }
          @media screen and (min-width: 1920px) {
            font-size: 16px;
          }
        }
        .tit {
          font-weight: bold;
          margin-bottom: 5px;
          font-weight: bold;
          color: #333;
          @media screen and (min-width: 140px) {
            font-size: 18px;
          }
          @media screen and (min-width: 1920px) {
            font-size: 24px;
          }
        }
        .content {
          padding-bottom: 8px;
          font-weight:400;
        }
        & > div {
          height: 27%;
        }
      }
    }
  }
}
.ability {
  .top {
    height: 160px;
    background-color: #333;
    div {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      height: 75%;
      width: fit-content;
      width: -webkit-fit-content;
      width: -moz-fit-content;
      margin: 0 auto;
      p {
        color: #ffffff;
        margin: 0;
        font-weight: bold;
        line-height: 20px;
        @media screen and (min-width: 140px) {
          font-size: 18px;
        }
        @media screen and (min-width: 1920px) {
          font-size: 24px;
        }
      }
      .num {
        font-size: 60px;
        color: #fce04f;
        // padding: 5px;
        font-family:Impact;
        border-bottom: 4px solid #fce04f;
        padding: 0 !important;
      }
      .power {
        padding-left: 30px;
        p{
          text-align: left;
        }
      }
    }
  }
  .content {
    display: flex;
    .content1 {
      width: 33.9375vw;
      height: 27.1354vw;
      position: relative;
      min-width: 407.25px;
      min-height: 325.6248px;
      img {
        width: 100%;
        height: 100%;
      }
      .content-first {
        height: 34%;
        background: rgba(0, 0, 0, 0.71);
        position: absolute;
        width: 100%;
        bottom: 0;
        display: flex;
        align-items: center;
        div {
          h1 {
            margin: 0;
            font-weight: bold;
            color: rgba(255, 255, 255, 1);
            line-height: 50px;
            text-align: left;
            margin-left: 65px;
            @media screen and (min-width: 140px) {
              font-size: 18px;
            }
            @media screen and (min-width: 1920px) {
              font-size: 24px;
            }
          }
          p {
            margin: 0;
            color: rgba(255, 255, 255, 1);
            text-align: left;
            margin-left: 65px;
            line-height: 20px;
            @media screen and (min-width: 140px) {
              font-size: 14px;
            }
            @media screen and (min-width: 1920px) {
              font-size: 16px;
            }
          }
        }
      }
    }
    .content2 {
      width: 38.59375vw;
      height: 27.1354vw;
      min-width: 463.125px;
      min-height: 325.62848px;
      img {
        width: 100%;
        height: 69.67%;
      }
      .content-second {
        height: 30.33%;
        background-color: #fce04f;
        display: flex;
        align-items: center;
        position: relative;
        div {
          h1 {
            margin: 0;
            font-weight: bold;
            color: rgba(51, 51, 51, 1);
            line-height: 50px;
            text-align: left;
            margin-left: 70px;
            @media screen and (min-width: 140px) {
              font-size: 18px;
            }
            @media screen and (min-width: 1920px) {
              font-size: 24px;
            }
            // padding-top: 5.76%;
          }
          p {
            margin: 0;
            color: rgba(51, 51, 51, 1);
            text-align: left;
            margin-left: 70px;
            line-height: 20px;
            @media screen and (min-width: 140px) {
              font-size: 14px;
            }
            @media screen and (min-width: 1920px) {
              font-size: 16px;
            }
          }
        }
        span {
          display: block;
          width: 0;
          height: 0;
          border-width: 30px 25px 0;
          border-style: solid;
          border-color: #fce04f transparent transparent; /*黄 透明 透明 */
          position: absolute;
          bottom: -30px;
          left: 48%;
        }
      }
    }
    .content3 {
      width: 27.34375vw;
      height: 27.3354vw;
      min-width: 328.125px;
      min-height: 329.6248px;
      img {
        width: 100%;
        height: 61.23%;
      }
      .content-third {
        height: 39.32%;
        background-color: #333333;
        display: flex;
        align-items: center;
        margin-top: -11px;
        div {
          h1 {
            margin: 0;
            font-weight: bold;
            color: rgba(255, 255, 255, 1);
            line-height: 50px;
            text-align: left;
            margin-left: 45px;
            @media screen and (min-width: 140px) {
              font-size: 18px;
            }
            @media screen and (min-width: 1920px) {
              font-size: 24px;
            }
          }
          p {
            margin: 0;
            color: rgba(255, 255, 255, 1);
            text-align: left;
            margin-left: 45px;
            line-height: 20px;
            @media screen and (min-width: 140px) {
              font-size: 14px;
            }
            @media screen and (min-width: 1920px) {
              font-size: 16px;
            }
          }
        }
      }
    }
  }
}
.innovation {
  padding-top: 120px;
  // width: 1240px;
  width: 65%;
  margin: 0 auto;
  padding-bottom: 50px;
  @media screen and (min-width: 140px) {
    width: 80%;
  }
  @media screen and (min-width: 1283px) {
      width: 65%;
  }
  // min-height: 790px;
  & > h1 {
    margin: 0;
    color: #fce04f;
    margin-bottom: 25px;
    span {
      border-bottom: 4px solid #fce04f;
      font-size: 60px;
      font-family: Impact;
      font-weight: 400;
      color: rgba(252, 224, 79, 1);
      line-height: 24px;
    }
  }
  h2 {
    margin: 0;
    font-weight: bold;
    @media screen and (min-width: 140px) {
      font-size: 18px;
    }
    @media screen and (min-width: 1920px) {
      font-size: 24px;
    }
  }
  h3 {
    margin: 0 0 50px 0;
    font-weight: bold;
    @media screen and (min-width: 140px) {
      font-size: 18px;
    }
    @media screen and (min-width: 1920px) {
      font-size: 24px;
    }
  }
  .ThreeContent {
    display: flex;
    justify-content: space-between;
    // min-width: 1240px;
    width: 100%;
    margin: 0 auto;
    div {
      width: 50%;
      img {
        width: 100%;
      }
    }
    .titAndcontent {
      display: flex;
      align-items: center;
      div {
        width: 71%;
        margin: 0 auto;
        h1 {
          color: #333;
          width: fit-content;
          width: -webkit-fit-content;
          width: -moz-fit-content;
          span {
            padding-bottom: 10px;
            border-bottom: 2px solid #000;
            font-weight:bold;
            @media screen and (min-width: 140px) {
              font-size: 24px;
            }
            @media screen and (min-width: 1920px) {
              font-size: 26px;
            }
          }
        }
        h2 {
          color: #666;
          margin: 30px 0 42px 0;
          font-weight:400;
          width: fit-content;
          width: -webkit-fit-content;
          width: -moz-fit-content;
          font-weight: bold;
          @media screen and (min-width: 140px) {
            font-size: 18px;
          }
          @media screen and (min-width: 1920px) {
            font-size: 24px;
          }
        }
        p {
          line-height: 36px;
          text-align: justify;
          color: #666;
          @media screen and (min-width: 140px) {
            font-size: 14px;
          }
          @media screen and (min-width: 1920px) {
            font-size: 16px;
          }
        }
      }
    }
  }
}
</style>
<style lang="less">
// .el-submenu__title:hover{
//   background-color: #fff !important;
// }
.el-submenu__title{
  color: #333 !important;
}
.el-submenu__title a{
  color: #333 !important;
}
// .el-carousel__container {
//   height: 500px;
// }
</style>
